import { CommonModule } from '@angular/common';
import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonIcon, IonItem, IonLabel, IonList, IonMenuToggle } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { AccountService } from '@okcargo-apps/shared-application-ionic';
import { CRUD_USERS_CAPABILITIES, ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { DECA_ROUTES } from '../../../deca/deca.routes.config';

@Component({
  selector: 'app-menu-main',
  templateUrl: './menu-main.component.html',
  styleUrls: ['./menu-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    IonList,
    IonItem,
    IonMenuToggle,
    IonIcon,
    IonLabel,
  ],
})
export class MenuMainComponent {
  private readonly accountService = inject(AccountService);

  protected readonly canAdministrativeDocuments = computed(() =>
    this.accountService.hasCapability(ECapabilities.ADMINISTRATIVE_DOCUMENTS),
  );
  protected readonly canUploadFreights = computed(() =>
    this.accountService.hasCapability(ECapabilities.UPLOAD_FREIGHTS),
  );
  protected readonly canCrudUsers = computed(() =>
    CRUD_USERS_CAPABILITIES.some((capability) => this.accountService.hasCapability(capability)),
  );
  protected readonly canCreateDeca = computed(() =>
    this.accountService.hasCapability(ECapabilities.CREATE_DECA_AS_SHIPPER),
  );
  protected readonly canViewDeca = computed(() =>
    this.accountService.hasCapability(ECapabilities.VIEW_DECA_AS_SHIPPER),
  );

  protected readonly DECA_ROUTES = DECA_ROUTES;

  // constructor() {}
}
